<app-scrollable-dialog headerKey="header.addPhoto">
  <ng-container content>
    <image-cropper
      class="cropper"
      #cropper
      [imageFile]="data.image"
      [maintainAspectRatio]="true"
      [containWithinAspectRatio]="containWithinAspectRatio"
      [aspectRatio]="data.aspectRatio"
      [resizeToWidth]="data.resizeToWidth"
      [roundCropper]="data.roundCropper"
      format="png"
      (imageCropped)="imageCropped($event)"
      (cropperReady)="cropperReady()"
      (loadImageFailed)="loadImageFailed()"
    >
    </image-cropper>
    <button mat-stroked-button class="fliko-stroked-button" (click)="onContainWithinAspectRatio()">
      {{ 'button.' + (containWithinAspectRatio ? 'cover' : 'contain') + 'Image' | loc }}
    </button>
    <app-loader *ngIf="loading"></app-loader>
  </ng-container>
  <ng-container actions>
    <button mat-stroked-button class="fliko-stroked-button" (click)="onSubmit()">{{ 'button.confirm' | loc }}</button>
    <button mat-stroked-button class="fliko-stroked-button" (click)="onCancel()">{{ 'button.cancel' | loc }}</button>
  </ng-container>
</app-scrollable-dialog>
